/** @jsx jsx */
import { jsx } from '@emotion/core';

import InlineMessage from '@atlaskit/inline-message';
import Heading from '@atlaskit/heading';

interface StatusAction {
  link: string;
  text: string;
}

type ComponentStatusType = 'Intent to deprecate' | 'Deprecated';

export interface ComponentStatus {
  type: ComponentStatusType;
  description: string;
  action: StatusAction;
  testId?: string;
}

interface InlineMessageContent {
  inlineMessageType: 'warning' | 'error';
  inlineMessageTitle: string;
  contentHeading: string;
}
type Props = {
  status?: ComponentStatus;
};

const mapStatusTypeToInlineMessageContent = (
  type: ComponentStatusType,
): InlineMessageContent => {
  switch (type) {
    case 'Intent to deprecate':
      return {
        inlineMessageType: 'warning',
        inlineMessageTitle: 'Use with caution',
        contentHeading: 'Intent to deprecate',
      };
    case 'Deprecated':
      return {
        inlineMessageType: 'error',
        inlineMessageTitle: 'Deprecated',
        contentHeading: 'Don’t use',
      };
  }
};

const ComponentStatusMessage = ({ status }: Props) => {
  const { type, description, action, testId } = status;

  const inlineMessageContent = mapStatusTypeToInlineMessageContent(type);

  if (inlineMessageContent === undefined) {
    return null;
  }

  return (
    <div css={{ paddingTop: '4px' }}>
      <InlineMessage
        title={inlineMessageContent.inlineMessageTitle}
        type={inlineMessageContent.inlineMessageType}
        testId={testId}
      >
        <Heading level="h400">{inlineMessageContent.contentHeading}</Heading>
        <p>{description}</p>
        {action && (
          <p>
            <a href={action.link}>{action.text}</a>
          </p>
        )}
      </InlineMessage>
    </div>
  );
};

export default ComponentStatusMessage;
